/**
 * Hooks for RAG Playground API
 */
import { useQuery, useMutation } from "@tanstack/react-query";
import { apiGet, apiPost } from "@/lib/api-client";
import type {
    PlaygroundSearchParams,
    PlaygroundSearchResponse,
    EntityTagCount,
} from "@/types/api/rag-playground";

export function usePlaygroundSearch() {
    return useMutation({
        mutationFn: async (
            params: PlaygroundSearchParams,
        ): Promise<PlaygroundSearchResponse> => {
            const response = await apiPost<PlaygroundSearchResponse>(
                "/admin/knowledge/playground/search",
                params,
            );
            return response as PlaygroundSearchResponse;
        },
    });
}

export function useEntityTagCounts() {
    return useQuery({
        queryKey: ["entity-tag-counts"],
        queryFn: async (): Promise<EntityTagCount[]> => {
            const response = await apiGet<{ success: boolean; data: EntityTagCount[] }>(
                "/admin/knowledge/playground/entity-tag-counts",
            );
            return (response as { data: EntityTagCount[] }).data || [];
        },
    });
}
